import { AQLogger } from "aq-logger";
import { CartApi, type CartPayloadGetCartItemsResponse, type LanguageCode } from "../../../generated/api-client";
import { generatedConfiguration } from "@/services/api/generated-client";
import type { LocaleCode } from "@/i18n/locales";
import { GENERAL_USER_ERROR_MESSAGE } from "@/services/api/service-errors";

const logger = new AQLogger("CartApi");
const cartClient = new CartApi(generatedConfiguration);

export const cartApi = {
    async getCart(locale: LocaleCode): Promise<CartPayloadGetCartItemsResponse> {
        try {
            logger.debug("Fetching cart...");
            const response = await cartClient.cartGetCartItems({ languageCode: locale as LanguageCode });
            if (response.reject || !response.data) {
                throw logger.exception("Failed to fetch cart.", "cart fetch rejected");
            }
            logger.success("Cart fetched.");
            return response.data;
        } catch (error) {
            throw logger.exception("Failed to fetch cart.", error);
        }
    },

    async changeQuantity(productId: string, quantityDelta: number, locale: LocaleCode): Promise<CartPayloadGetCartItemsResponse> {
        try {
            logger.debug("Updating cart quantity...");
            const response = await cartClient.cartAddCartItem({
                cartPayloadAddCartItemRequest: { productId, quantity: quantityDelta, languageCode: locale }
            });
            if (response.reject || !response.data) {
                throw logger.exception("Failed to update cart quantity.", "cart quantity update rejected");
            }
            logger.success("Cart quantity updated.");
            return response.data;
        } catch (error) {
            throw logger.exception("Failed to update cart quantity.", error);
        }
    }
};
